import { render, staticRenderFns } from "./MarcarUsoComprobante.vue?vue&type=template&id=ff6335ec"
import script from "./MarcarUsoComprobante.vue?vue&type=script&lang=js"
export * from "./MarcarUsoComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports